<template>
  <project-template title="配置病种量表" nextBtnText="下一步：随访周期" @lastClick="lastClick" @nextClick="nextClick">
    <template v-slot:leftContent>
      <div class="module">
        <div class="title1">
          <recommand-module></recommand-module>
          <h3>已选择通用模块</h3>
        </div>
        <div class="wrap">
          <div class="list list1" v-if="options0.length !== 0">
            <a-checkbox :class="['item', cur === index ? 'cur' : '']" @click="handleClick(item, index)"
              checked="checked" v-for="(item, index) in options0" :key="item.label">
              <recommand-module></recommand-module>
              <em>
                {{ item.name }}
              </em>
              <strong>{{ item.selected === 0 ? '待配置' : item.selected + '/' + item.total }}</strong>
            </a-checkbox>
          </div>
          <a-empty v-else class="empty"></a-empty>
        </div>
      </div>
      <br>
      <div class="module">
        <div class="title1">
          <specialist-module></specialist-module>
          <h3>已选择专科模块</h3>
        </div>
        <div class="wrap">
          <div class="list list1" v-if="options1.length !== 0">
            <a-checkbox :class="['item', cur === options0.length + index ? 'cur' : '']"
              @click="handleClick(item, options0.length + index)" checked="checked" v-for="(item, index) in options1"
              :key="item.label">
              <recommand-module></recommand-module>
              <em>
                {{ item.name }}
              </em>
              <strong>{{ item.selected === 0 ? '待配置' : item.selected + '/' + item.total }}</strong>
            </a-checkbox>
          </div>
          <a-empty v-else class="empty"></a-empty>
        </div>
      </div>
    </template>
    <template v-slot:rightContent>
      <div style="height: calc(100% - 70px);overflow: auto;">
        <div class="gauge">
          <div class="title1">
            <h2>为你推荐</h2>
            <span>已选{{ selected1.length }}个</span>
          </div>
          <div class="wrap">
            <div class="list" v-if="options2.length !== 0">
              <div v-for="item in options2" :key="item.code" class="item">
                <a-checkbox :checked="item.checked" @change="onChange($event, item)"></a-checkbox>
                <div class="info" @click="formView(item.code)">
                  <!-- <icon-city class="icon-show"></icon-city> -->
                  <div class="line1">
                    <strong>{{ item.name }}</strong>
                    <div class="component">
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         到院随访
                        </template>
                        <component :is="'icon-in-hospital'" v-show="isShowVisit(item.extend, '1')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         电话随访
                        </template>
                        <component :is="'icon-phone-visit'" v-show="isShowVisit(item.extend, '0')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         他评
                        </template>
                        <component :is="'icon-other-common'" v-show="isShowCommon(item, '0')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         自评
                        </template>
                        <component :is="'icon-self-common'" v-show="isShowCommon(item, '1')"></component>
                      </a-tooltip>
                      <!-- <component :is="'icon-phone-visit'" v-show="isShowVisit(item.extend, '0')"></component>
                      <component :is="'icon-in-hospital'" v-show="isShowVisit(item.extend, '1')"></component>
                      <component :is="'icon-other-common'" v-show="isShowCommon(item, '0')"></component>
                      <component :is="'icon-self-common'" v-show="isShowCommon(item, '1')"></component> -->
                    </div>

                  </div>
                  <div class="line2">
                    <dl>
                      <dt>用时</dt>
                      <dd>{{ item.useTime }}min</dd>
                    </dl>
                    <dl>
                      <dt>题目数量</dt>
                      <dd>{{ item.number }}个</dd>
                    </dl>
                  </div>

                  <div class="line2">
                    <dl>
                      <dt>功能</dt>
                      <dd>{{ item.useInfo || '-' }}</dd>
                    </dl>
                  </div>
                  <div class="line2">
                    <dl style="margin-bottom: 6px;">
                      <dt>总推荐值</dt>
                      <dd>
                        <!-- <a-rate :allow-clear="false" :default-value="item.score" disabled /> -->
                        <my-rate v-model="item.score">
                          <template v-slot:default="{ index }">
                            <icon-star v-show="item.score > index" fill="#FCA04B"></icon-star>
                            <icon-star v-show="item.score <= index" fill="#B4B7BF"></icon-star>
                          </template>
                        </my-rate>
                      </dd>
                    </dl>
                  </div>
                  <div class="line2">
                    <dl style="margin-bottom: 6px;">
                      <dt>专家评价</dt>
                      <dd>
                        <a-rate :allow-clear="false" :default-value="3" disabled />
                      </dd>
                      <!-- <a-progress :percent="expertProgress(item.extend)" disabled></a-progress> -->
                    </dl>
                    <dl style="margin-bottom: 6px;">
                      <dt>简易程度</dt>
                      <dd>
                        <a-rate :allow-clear="false" :default-value="4" disabled />
                      </dd>
                      <!-- <a-progress :percent="evaluateProgress(item.extend)">
                      </a-progress> -->
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <a-empty v-else class="empty"></a-empty>
          </div>
        </div>
        <br>
        <div class="gauge">
          <div class="title1">
            <h2>其它量表</h2>
            <span>已选{{ selected2.length }}个</span>
          </div>
          <div class="wrap">

            <div class="list" v-if="options3.length !== 0">
              <div v-for="item in options3" :key="item.code" class="item">
                <a-checkbox :checked="item.checked" @change="onChange($event, item)"></a-checkbox>
                <div class="info" @click="formView(item.code)">
                  <div class="line1">
                    <strong>{{ item.name }}</strong>
                    <div class="component">
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         到院随访
                        </template>
                        <component :is="'icon-in-hospital'" v-show="isShowVisit(item.extend, '1')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         电话随访
                        </template>
                        <component :is="'icon-phone-visit'" v-show="isShowVisit(item.extend, '0')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         他评
                        </template>
                        <component :is="'icon-other-common'" v-show="isShowCommon(item, '0')"></component>
                      </a-tooltip>
                      <a-tooltip placement="topLeft" style="padding-left:2px">
                        <template slot="title">
                         自评
                        </template>
                        <component :is="'icon-self-common'" v-show="isShowCommon(item, '1')"></component>
                      </a-tooltip>
                      <!-- <component :is="'icon-phone-visit'" v-show="isShowVisit(item.extend, '0')"></component>
                      <component :is="'icon-in-hospital'" v-show="isShowVisit(item.extend, '1')"></component>
                      <component :is="'icon-other-common'" v-show="isShowCommon(item, '1')"></component>
                      <component :is="'icon-self-common'" v-show="isShowCommon(item, '0')"></component> -->
                    </div>
                  </div>
                  <div class="line2">
                    <dl>
                      <dt>用时</dt>
                      <dd>{{ item.useTime }}min</dd>
                    </dl>
                    <dl>
                      <dt>题目数量</dt>
                      <dd>{{ item.number }}个</dd>
                    </dl>
                  </div>
                  <div class="line2">
                    <dl>
                      <dt>功能</dt>
                      <dd>{{ item.useInfo || '-' }}</dd>
                    </dl>
                  </div>
                  <div class="line2">
                    <dl style="margin-bottom: 6px;">
                      <dt>总推荐值</dt>
                      <dd>
                        <!-- <a-rate :allow-clear="false" :default-value="item.score" disabled /> -->
                        <my-rate v-model="item.score">
                          <template v-slot:default="{ index }">
                            <icon-star v-show="item.score > index" fill="#FCA04B"></icon-star>
                            <icon-star v-show="item.score <= index" fill="#B4B7BF"></icon-star>
                          </template>
                        </my-rate>
                      </dd>
                    </dl>
                  </div>
                  <div class="line2">
                    <dl style="margin-bottom: 6px;">
                      <dt>专家评价</dt>
                      <dd>
                        <a-rate :allow-clear="false" :default-value="3" disabled />
                      </dd>
                      <!-- <a-progress :percent="expertProgress(item.extend)" disabled></a-progress> -->
                    </dl>
                    <dl style="margin-bottom: 6px;">
                      <dt>简易程度</dt>
                      <dd>
                        <a-rate :allow-clear="false" :default-value="4" disabled />
                      </dd>
                      <!-- <a-progress :percent="evaluateProgress(item.extend)">
                      </a-progress> -->
                    </dl>
                  </div>

                </div>
              </div>
            </div>
            <a-empty v-else class="empty"></a-empty>
          </div>
        </div>
        <!-- 评分组件 -->
        <!-- <br>
        <br>
        <br>
        <my-rate :value="rating">
          <template v-slot:default="{ index }">
            <icon-star v-show="rating > index" fill="#FCA04B"></icon-star>
            <icon-star v-show="rating <= index" fill="#B4B7BF"></icon-star>
          </template>
        </my-rate>
        <hr>
        <my-rate v-model="rating">
          <template v-slot:default="{ index }">
            <icon-star v-show="rating > index" fill="#FCA04B"></icon-star>
            <icon-star v-show="rating <= index" fill="#B4B7BF"></icon-star>
          </template>
        </my-rate> -->
        <!-- 评分组件 -->
      </div>



      <div class="btn-list">
        <!-- <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            自定义量表 <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item>
              <a href="javascript:;" @click="formDiyClick">上传量表</a>
            </a-menu-item>
            <a-menu-item>
              <a href="javascript:;" @click="formDiyListClick">历史上传</a>
            </a-menu-item>
          </a-menu>
        </a-dropdown> -->

        <!-- <a-button class="btn1" @click="lastItem">上一模块</a-button>
        <a-button class="btn1" @click="nextItem">下一模块</a-button> -->
      </div>
      <a-drawer title="表单信息全览" width="90%" :closable="false" @close="onViewClose" :visible="viewVisible">
        <div style="font-size: 18px;font-weight: bold;text-align: center;margin-bottom: 10px">
          {{ current.name }}
        </div>
        <a-spin :spinning="confirmLoading">
          <a-form>
            <a-tabs v-model:activeKey="customActiveKey" :tabBarStyle="{ textAlign: 'left', borderBottom: 'unset' }">
              <a-tab-pane key="1" tab="基本信息">
                <form-base-modal :model="current" ref="formbasemodal"></form-base-modal>
              </a-tab-pane>
              <a-tab-pane key="2" tab="扩展信息">
                <form-extend-modal :model="formExtend"></form-extend-modal>
              </a-tab-pane>
              <a-tab-pane key="3" tab="表单题目">
                <base-form-view :base-data="current"></base-form-view>
              </a-tab-pane>
            </a-tabs>
          </a-form>
        </a-spin>

      </a-drawer>
      <module-form-diy ref="module-form-diy" :moduleList="[...options0, ...options1]" :project="project"
        :diseaseCode="diseaseCode"></module-form-diy>
      <module-form-diy-list ref="module-form-diy-list" :project="project"
        :diseaseCode="diseaseCode"></module-form-diy-list>
    </template>
  </project-template>
</template>

<script>
import MyRate from './MyRate.vue';
import { cloneObject } from '@/utils/util'
import { getAction, postAction } from '@api/manage'
import ProjectTemplate from '@comp/pad/ProjectTemplate'
import RecommandModule from '@comp/Icon/RecommandModule'
import SpecialistModule from '@comp/Icon/SpecialistModule'
import BaseFormView from '@comp/form/BaseFormView'
import ModuleFormDiy from '@views/apppad/projectTemplate/projectTemplate2/ModuleFormDiy'
import ModuleFormDiyList from '@views/apppad/projectTemplate/projectTemplate2/ModuleFormDiyList'
import FormExtendModal from '@views/tempconfig/modules/formmodal/FormExtendModal'
import FormBaseModal from '@views/tempconfig/modules/formmodal/FormBaseModal'
export default {
  name: 'StepFour',
  components: { ProjectTemplate, RecommandModule, SpecialistModule, BaseFormView, ModuleFormDiy, ModuleFormDiyList, MyRate, FormExtendModal, FormBaseModal  },
  data() {
    return {
      cur: 0,
      selectedModule: [],
      allGauge: [],
      options2: [],
      options3: [],
      selected1: [],
      selected2: [],
      current: {},
      project: {},
      diseaseCode: '',
      viewVisible: false,
      saved: false,
      rating: 4,
      customActiveKey: '1',
      confirmLoading: false,
      formExtend:{},
    }
  },
  watch: {
    options2: {
      handler() {
        this.selected1 = this.options2.filter(item => item.checked === true)
      },
      immediate: true,
      deep: true
    },
    options3: {
      handler() {
        this.selected2 = this.options3.filter(item => item.checked === true)
      },
      immediate: true,
      deep: true
    },
  },
  computed: {
    options0: function () {
      return this.selectedModule.filter(item => item.type === '1')
    },
    options1: function () {
      return this.selectedModule.filter(item => item.type === '2')
    },
  },
  mounted() {    
    this.loadProjectData();
  },
  methods: {
    expertProgress(value) {
      if (value === null || JSON.parse(value).simplicity === null) {
        return 30
      } else {
        const simplicity = JSON.parse(value).simplicity
        const rate = (simplicity / 5) * 100
        return parseFloat(rate.toFixed(2))
      }
    },
    evaluateProgress(value) {
      if (value === null || JSON.parse(value).evaluate === null) {
        return 30
      } else {
        const evaluate = JSON.parse(value).evaluate
        const rate = (evaluate / 5) * 100
        return parseFloat(rate.toFixed(2))
      }
    },
    isShowCommon(value, type) {
      if (value.testType === null) {
        return false
      } else {
        if (value.testType === type || value.testType === '2') {
          return true
        } else {
          return false
        }
      }
    },
    isShowVisit(value, type) {
      if (value === null || JSON.parse(value).phoneType === null) {
        return false
      } else {
        const phoneType = JSON.parse(value).phoneType
        if (phoneType === type || phoneType === '2') {
          return true
        } else {
          return false
        }
      }
    },
    log(s, o) {
      console.log(s, JSON.parse(JSON.stringify(o)))
    },
    async loadProjectData() {
      const id = this.$route.query.id
      const res = await getAction('/projectconfigview/configProject/queryById', { id })
      if (res.success) {
        this.project = res.result;
        this.diseaseCode = JSON.parse(res.result.diseaseJson)[0].code;
        this.getGauge()
      }
    },
    async getGauge() {
      const id = this.$route.query.id;
      const arr = JSON.parse(sessionStorage.getItem('selectedModule') || '[]');
      this.log('arr', arr)
      const moduleIds = arr.map(item => item.id).join(',');

      const res = await getAction('/projectconfigview/configForm/listByProjectConfigId', { moduleIds, id });
      if (res.success) {        
        const obj = {}
        this.allGauge = res.result.map(item => {
          if(item.moduleId.indexOf(',')>-1){
            let modules = item.moduleId.split(",")
            modules.forEach(id=>{
              if (obj[id]) {
                obj[id].push(item)
              } else {
                obj[id] = [item]
              }
            })
          }else{
            if (obj[item.moduleId]) {
              obj[item.moduleId].push(item)
            } else {
              obj[item.moduleId] = [item]
            }
          }
          item.checked = item.score >= 4.5 ? true : false;
          
          if (this.project.moduleJson) {// 编辑时，已经选择的表单也要选中
            const moduleObject = JSON.parse(this.project.moduleJson)
            for (let key in moduleObject) {
              const moduleList = moduleObject[key]
              console.log("moduleList-------")
              moduleList.forEach(module => {
                if(module.id === item.moduleId || item.moduleId.indexOf(module.id)>=0){
                  if (module.checkedFormList) {
                    module.checkedFormList.forEach(form => {
                      if(form.id === item.id){
                        item.checked = true
                      }
                    })
                  }
                }
              })
            }
          }
          return item;
        });
        this.log('obj', obj)
        arr.forEach(item => {          
          item.total = (obj[item.id] || []).length;
          item.selected = (obj[item.id] || []).filter(list => list.checked === true).length;
        })
        // if(obj['0']){
        //   console.log("obj['0']:" + obj['0'])
        //   arr.forEach(item => {          
        //     var formlist = obj['0'].filter(list => list.moduleId === '0' && item.tempConfigDeptDiseases && item.tempConfigDeptDiseases.some(di => di.deptId === list.deptId))
        //     for(var i =0;i< formlist.length;i++ ){
        //       var list = formlist[i]
        //       if(list.submajorId){
        //         if(!item.tempConfigDeptDiseases.some(di => di.submajorId === list.submajorId)){
        //           continue
        //         }
        //       }
        //       item.total = item.total + 1
        //       if (list.score >= 4.5) {
        //         item.selected = item.selected + 1
        //       } 

        //     }
        //   })
        // }       

        this.selectedModule = arr;
        this.handleClick(this.options0[0], 0)
      }
    },
    handleClick(item, index) {
      if(!item){
        return
      }
      const arr1 = [];
      const arr2 = [];
      this.cur = index;
      this.allGauge.filter(list => list.moduleId === item.id || list.moduleId.indexOf(item.id)>-1).forEach(list => {
        if (list.score >= 4.5) {
          arr1.push(list)
        } else {
          arr2.push(list)
        }
      })
      // console.log("item.tempConfigDeptDiseases"+item.tempConfigDeptDiseases)
      // //所有模块的情况
      // var formlist = this.allGauge.filter(list => list.moduleId === '0' && item.tempConfigDeptDiseases && item.tempConfigDeptDiseases.some(di => di.deptId === list.deptId))
      // for(var i =0;i< formlist.length;i++ ){
      //   var list = formlist[i]
      //   if(list.submajorId){
      //     if(!item.tempConfigDeptDiseases.some(di => di.submajorId === list.submajorId)){
      //       continue
      //     }
      //   }
      //   if (list.score >= 4.5) {
      //     arr1.push(list)
      //   } else {
      //     arr2.push(list)
      //   }
      // }

      this.options2 = arr1;
      this.options3 = arr2;
      item.selected = (this.options2 || []).filter(list => list.checked === true).length + (this.options3 || []).filter(list => list.checked === true).length
    },
    onChange(ev, item) {
      const { checked } = ev.target
      this.allGauge.forEach(k => {
        if (k.code === item.code) {
          k.checked = checked;
        }
      })

      if (checked) {
        this.selectedModule[this.cur].selected++
      } else {
        this.selectedModule[this.cur].selected--
      }
    },

    formView(code) {
      getAction('/tempconfig/tempConfigForm/getInfoByCode', { code }).then(res => {
        if (res.success) {
          this.current = res.result
          this.formExtend=JSON.parse(this.current.extend)||{};
          this.viewVisible = true
        }
      })
    },

    onViewClose() {
      this.viewVisible = false
    },
    formDiyClick() {
      this.$refs['module-form-diy'].open()
    },
    formDiyListClick() {
      this.$refs['module-form-diy-list'].open()
    },
    lastItem() {
      const arr = [...this.options0, ...this.options1];
      if (this.cur === 0) {
        this.$message.warning('目前已是第一个模块了，请配置模块中的量表')
      } else {
        this.handleClick(arr[this.cur - 1], this.cur - 1)
      }
    },
    nextItem() {
      const arr = [...this.options0, ...this.options1];
      if (this.cur === arr.length - 1) {
        this.$message.warning('目前已是最后模块配置，如模块量表配置结束，请点击“下一步：配置周期”按钮')
      } else {
        this.handleClick(arr[this.cur + 1], this.cur + 1)
      }
    },
    async saveForm() { //保存表单
      const obj = {};
      const arr = cloneObject(this.selectedModule);
      console.log('开始保存')
      let selectFormList = this.allGauge.filter(item => item.checked)
      if (selectFormList.length === 0) {
        this.$message.warning('请选择量表')
        return false
      }
      selectFormList.forEach(item => {
        if(item.moduleId.indexOf(',')>-1){
            let modules = item.moduleId.split(",")
            modules.forEach(id=>{
              if (obj[id]) {
                obj[id].push(item)
              } else {
                obj[id] = [item]
              }
            })
          }else{
            if (obj[item.moduleId]) {
              obj[item.moduleId].push(item)
            } else {
              obj[item.moduleId] = [item]
            }
          }
      })

      arr.forEach(item => {
        item.checkedFormList = obj[item.id]
      })
      // //处理属于所有模块的表单
      // var formlist = selectFormList.filter(list => list.moduleId === '0')
      // for(var i =0;i< formlist.length;i++ ){
      //   var list = formlist[i]
      //   for(var j = 0; j<arr.length; j++){
      //     var moduleItem = arr[j]
      //     if(moduleItem.tempConfigDeptDiseases && moduleItem.tempConfigDeptDiseases.some(di => di.deptId === list.deptId)){
      //       if(list.submajorId){
      //           if(!moduleItem.tempConfigDeptDiseases.some(di => di.submajorId === list.submajorId)){
      //             continue
      //           }
      //         }
      //         moduleItem.checkedFormList = moduleItem.checkedFormList || []
      //         list.moduleId = moduleItem.id//将属于所有模块的表单 保存赋值为当前模块
      //         moduleItem.checkedFormList.push(list)
      //         break
      //     }
      //   }
      // }      
      
      const res = await postAction('/projectconfigview/configProject/saveModule', {
        id: this.$route.query.id,
        moduleJson: JSON.stringify({
          [this.diseaseCode]: arr
        }),
      });
      if (res.success) {
        this.$message.success(res.message);
        return true
      }
      return false
    },
    async nextClick() {
      let result = await this.saveForm()
      if (result) this.$emit('next')
    },
    lastClick() {
      this.$emit('last')
    }
  }
}
</script>

<style scoped lang="less">
.empty {
  color: white;
}

.module {
  .title1 {
    display: flex;
    align-items: center;
    column-gap: 10px;

    h3 {
      font-size: 18px;
      color: white;
      margin: 0;
    }
  }

  .wrap {
    min-height: 200px;
    display: flex;
    align-items: flex-start;
    justify-content: center;
  }

  .list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 10px;

    .item {
      position: relative;
      height: 80px;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;

      /deep/ .ant-checkbox+span {
        display: flex;
        flex-direction: column;
        margin-top: 18px;
      }


      em {
        font-style: normal;
        color: white;
      }

      strong {
        position: absolute;
        left: 50%;
        top: 0;
        transform: translateX(-50%);
        color: white;
        font-weight: normal;
      }
    }
  }

  .list1 {
    .cur {
      background: #376eff;
    }

    /deep/ .ant-checkbox {
      position: absolute;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #f5f5f5;
      border-color: #d9d9d9;
    }

    /deep/ .ant-checkbox-checked .ant-checkbox-inner::after {
      border-color: #b7b7b7;
    }
  }
}

.gauge {
  padding: 15px;
  background: rgba(255, 255, 255, 0.15);
  border-radius: 12px 12px 12px 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);

  .title1 {
    display: flex;
    align-items: center;

    h2 {
      font-size: 18px;
      color: white;
      margin: 0 10px 0 0;
    }

    span {
      font-weight: 400;
      font-size: 12px;
      color: rgba(255, 255, 255, 0.7);
    }
  }

  .list {
    width: 100%;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 10px;
    justify-content: center;
    margin-top: 12px;

    /deep/ .ant-checkbox-wrapper {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
    }

    /deep/ .ant-checkbox-checked .ant-checkbox-inner {
      background-color: #376eff;
      border-color: #376eff;
    }

    .item {
      position: relative;
      background: rgba(255, 255, 255, 0.15);
      border-radius: 12px;
      margin-left: 0;
      padding: 10px 0;

      /deep/ .ant-checkbox+span {
        display: block;
      }

      em {
        font-style: normal;
        color: white;
      }
    }

    .info {
      position: relative;
      margin-left: 35px;

      .icon-show {
        position: absolute;
        right: 16px;
        top: 3px;
      }

      .line1 {
        strong {
          font-weight: 600;
          font-size: 14px;
          color: #FFFFFF;
        }

        span {
          display: inline-block;
          font-weight: 400;
          font-size: 12px;
          color: #FFFFFF;
          padding: 3px 5px;
          margin-left: 5px;
          background: #343546;
          border-radius: 4px;
        }

        .component {
          margin-left: 200px;
          display: inline-block;
          position: absolute;
          right: 16px;
          top: 3px;
        }

      }



      .line2 {
        padding: 3px 0;

        dl {
          display: flex;
          margin: 0;
          align-items: center;
        }

        dt {
          font-weight: 400;
          font-size: 12px;
          color: rgba(255, 255, 255, 0.4);
          line-height: 14px;
          word-break: keep-all
        }

        dd {
          font-weight: 400;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.7);
          line-height: 16px;
          margin: 0 0 0 10px;
        }

        /deep/ .ant-rate {
          font-size: 12px;
        }

        .ant-progress {
          max-width: 145px;
          width: 100%;
          margin: 'auto';
        }
      }
    }
  }
}

.btn-list {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  display: flex;
  align-items: center;
  column-gap: 10px;
  padding: 15px 20px;

  a {
    font-weight: 400;
    font-size: 14px;
    color: #FCA04B;
  }

  button {
    height: 40px;
    font-weight: 400;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    background: rgba(255, 255, 255, 0.15);
    border-radius: 44px 44px 44px 44px;
    border: none;
  }

  .btn1 {
    flex: 1;
  }

  .btn2 {
    flex: 1;
    color: white;
    background: linear-gradient(90deg, #376EFF 0%, #DE5DFE 100%);
    border: none;
  }
}
</style>
